module.exports = __webpack_public_path__ + "img/nivel-bronze.3b672689.svg";